import React from "react"
import PropTypes from "prop-types"
import Icon from "components/Icon"
import sheetConstants from "sheets/constants"

export const RemoveRowButton = ({ datumId, removeRow, optionalActionCreator, id, swalConfig, dataPlumId }) => {
    const handleClick = async () => {
        const willDelete = await swal(swalConfig)
        if (willDelete) {
            removeRow(id, datumId, optionalActionCreator)
        }
    }

    return <Icon name="minus-circle" onClick={handleClick} data-plum-id={dataPlumId} />
}

RemoveRowButton.propTypes = {
    datumId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    optionalActionCreator: PropTypes.func,
    removeRow: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    swalConfig: PropTypes.object,
    dataPlumId: PropTypes.string,
}

RemoveRowButton.defaultProps = {
    optionalActionCreator: undefined,
    swalConfig: sheetConstants.DEFAULT_SWAL_CONFIG,
}

export default RemoveRowButton
